const BlockB = ({blockTitle, blockContent, hasInput, inputLabel, inputDescription}) => {

    return(
        <>
            <div className="form-container">
  <div className="form-head">
    <p className="text-center">{blockTitle}</p>
  </div>
  <div className="be-form p-3 p-md-5">
    <form action="">
      <div className="row">
        {blockContent.map((item, index) => 
            <div className="col-12 col-md-4" key={index}>
                <label className="label-utility">
                    <input
                    type="radio"
                    name="type_batiment"
                    defaultValue="habitation"
                    className="utility-radio"
                    />
                    <div className="utility mb-3">
                        <span>{item.title}</span>
                    </div>
                </label>
            </div>
        )}
      </div>
      {hasInput && 
        <div className="" style={{ maxWidth: 450, marginTop: 40 }}>
          <label className="label-be">{inputLabel}</label>
          <input type="text" />
        </div>
      }
    </form>
  </div>
</div>
        </>
    )

}

export default BlockB